import styled from 'styled-components';

const Container = styled.div`
  ${({ theme }) => theme.fontFamily.mainFont.smallExtraBold};
  ${({ theme }) => theme.commons.tabsContainer};
  background: ${({ theme }) => theme.colors.corporateWhite};
`;

export default Container;
